angular.module('cvsApp').service('searchNonPatientDataService', ['networkService', 'xdrService', 'configManager',
    'searchNonPatientDataModel', 'cvsAppData', '$base64', function (NS, XS, CM, SNPM, CAD, $base64) {

        function searchNonPatientDataService() {
            this.searchNonPatientDataService = function (callBackSuccess, oSearchNonPatientData) {
                var apikey = CAD.getApiKey();
                var params = "&tokenID=" + oSearchNonPatientData.tokenID + "&tokenType=SuperUser";
                var url = CM.getApiUrlWithApikeyAndAppName('SEARCH_NON_PATIENT_DATA', cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB') + params;

                if (url === "URL_ERROR") {

                } else {
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/xml',
                            'accept': 'application/xml'
                        },
                        data: requestBody(oSearchNonPatientData),
                        onSuccess: callBackSuccess
                    }
                    cvsUtility.commonServiceCode(url, "searchNonPatientData", SNPM, request, callBackSuccess, NS);
                }

            }

            var requestBody = function (oSearchNonPatientData) {
                var apikey = CAD.getApiKey();
                var reqObj = {
                    "searchNonPatientDataRequest": {
                        "header": {
                            "serviceContext": {
                                "appName": 'Portal',
                                "lineOfBusiness": "Specialty",
                                "channelName": cvsUtility.queryMap.channel,
                                "responseFormat": "XML",
                                "tokenID": oSearchNonPatientData.tokenID,
                                "tokenType": "SuperUser"
                            },
                            "securityContext": {
                                "apiKey": apikey,
                                "securityType": "apiKey"
                            }
                        },
                        "details": {
                            "searchNonPatientRequest": {
                                "searchMonth": oSearchNonPatientData.searchMonth,
                                "searchStartRange": oSearchNonPatientData.searchStartRange,
                                "searchResultsCount": oSearchNonPatientData.searchResultsCount
                            }
                        }
                    }
                };

                reqObj = {
                    "searchNonPatientRequest": {
                        "searchMonth": oSearchNonPatientData.searchMonth,
                        "searchStartRange": oSearchNonPatientData.searchStartRange,
                        "searchResultsCount": oSearchNonPatientData.searchResultsCount
                    }
                }
                var x2js = new X2JS();
                return x2js.json2xml_str(reqObj);
            };

        }

        return new searchNonPatientDataService();
    }]);